import { IBookingOnlineAction, IBookingOnlineState } from '../type';

function Reducer(state:IBookingOnlineState, action:IBookingOnlineAction):IBookingOnlineState {
  if (action.type === 'fetch') {
    return {
      ...state,
      loading: true,
    };
  }
  if (action.type === 'success') {
    const {
      mediaList, desiredCourse, courseCategoryList, headQuaterData, listOrgMaster, reservationExistingClient, reservationNewClient, filterExistingClientCategory, filterNewClientCategory,
    } = action.payload;

    return {
      ...state,
      courseCategoryList,
      headQuaterData,
      listOrgMaster,
      reservationExistingClient,
      reservationNewClient,
      filterExistingClientCategory,
      filterNewClientCategory,
      desiredCourse,
      loading: false,
      mediaList,
    };
  }
  if (action.type === 'showParentalForm') {
    return {
      ...state,
      showParentalForm: action.payload,
    };
  }
  if (action.type === 'changeCourseCategory') {
    return {
      ...state,
      desiredCourse: action.payload,
    };
  }
  if (action.type === 'fetchCalendar') {
    return {
      ...state,
      loadingCalendar: true,
    };
  }
  if (action.type === 'updateCalendar') {
    const {
      privateHolidays, publicDays, selectedCallDays, selectedDays, publicHolidayList,
    } = action.payload;
    return {
      ...state,
      publicDays,
      selectedCallDays,
      selectedDays,
      loadingCalendar: false,
      publicHolidayList,
      privateHolidays,
    };
  }
  if (action.type === 'changeCourseTime') {
    return {
      ...state,
      desiredTime: action.payload,
    };
  }
  if (action.type === 'errorCalendar') {
    return {
      ...state,
      errorCalendar: action.payload,
      loadingCalendar: false,
      desiredTime: [],
    };
  }
  if (action.type === 'changeTreatmentTimeAndCourseGroupID') {
    const {
      desiredTime, weekdayEnd, weekendEnd, holidayEnd, filterEndtime,
    } = state;
    const {
      courseGroupID, treatmentTime, treatmentTimeOld, timeZone,
    } = action.payload;
    const treatmentTimeValue = (treatmentTime / 60); // time is option now
    const treatmentTimeOldValue = (treatmentTimeOld / 60); // time is option old
    if (desiredTime) {
      return {
        ...state,
        weekdayEnd: (weekdayEnd + treatmentTimeOldValue) - treatmentTimeValue,
        weekendEnd: (weekendEnd + treatmentTimeOldValue) - treatmentTimeValue,
        holidayEnd: (holidayEnd + treatmentTimeOldValue) - treatmentTimeValue,
        filterEndtime: (filterEndtime + treatmentTimeOldValue) - treatmentTimeValue,
        treatmentTime,
        courseGroupID,
        timeZone,
      };
    }
    return {
      ...state,
      treatmentTime,
      courseGroupID,
      timeZone,
    };
  }
  if (action.type === 'storeSetting') {
    return {
      ...state,
      weekdayStart: action.payload.weekdayStart,
      weekdayEnd: action.payload.weekdayEnd,
      weekendStart: action.payload.weekendStart,
      weekendEnd: action.payload.weekendEnd,
      holidayStart: action.payload.holidayStart,
      holidayEnd: action.payload.holidayEnd,
      filterStartime: action.payload.filterStartime,
      filterEndtime: action.payload.filterEndtime,
      publicHoliday: action.payload.publicHoliday,
      showTime: true,
      possibleDayCode: null,
      possibleMonthCode: action.payload.possibleMonthCode,
      reservationStoreSettingReserveFrameRespons: action.payload.reservationStoreSettingReserveFrameRespons,
      regularHolidayFriday: action.payload.regularHolidayFriday,
      regularHolidayMonday: action.payload.regularHolidayMonday,
      regularHolidaySaturday: action.payload.regularHolidaySaturday,
      regularHolidaySunday: action.payload.regularHolidaySunday,
      regularHolidayThursday: action.payload.regularHolidayThursday,
      regularHolidayTuesday: action.payload.regularHolidayTuesday,
      regularHolidayWednesday: action.payload.regularHolidayWednesday,
    };
  }
  if (action.type === 'filterCalendar') {
    return {
      ...state,
      filterPublicDays: action.payload.filterPublicDays,
      filterSelectedCallDays: action.payload.filterSelectedCallDays,
      filterSelectedDays: action.payload.filterSelectedDays,
    };
  }
  if (action.type === 'resetStoreSetting') {
    return {
      ...state,
      weekdayStart: 0,
      weekdayEnd: 0,
      weekendStart: 0,
      weekendEnd: 0,
      holidayStart: 0,
      holidayEnd: 0,
      filterStartime: 0,
      filterEndtime: 0,
      publicHoliday: true,
      showTime: false,
      possibleMonthCode: null,
      possibleDayCode: null,
      reservationStoreSettingReserveFrameRespons: null,
      regularHolidayFriday: false,
      regularHolidayMonday: false,
      regularHolidaySunday: false,
      regularHolidayThursday: false,
      regularHolidayTuesday: false,
      regularHolidayWednesday: false,
      regularHolidaySaturday: false,
      desiredTime: [],
    };
  }
  if (action.type === 'submit') {
    if (action.payload) {
      return {
        ...state,
        loading: false,
        desiredTime: null,
        error: '',
        publicDays: [],
        selectedDays: [],
        selectedCallDays: [],
        loadingCalendar: false,
        errorCalendar: '',
        filterPublicDays: [],
        filterSelectedCallDays: [],
        filterSelectedDays: [],
        treatmentTime: 0,
        weekdayStart: 0,
        weekdayEnd: 0,
        weekendStart: 0,
        weekendEnd: 0,
        holidayStart: 0,
        holidayEnd: 0,
        filterStartime: 0,
        filterEndtime: 0,
        publicHoliday: true,
        publicHolidayList: [],
        desiredCourse: null,
        showTime: false,
        possibleMonthCode: null,
        possibleDayCode: null,
        courseGroupID: null,
        reservationStoreSettingReserveFrameRespons: null,
        regularHolidayFriday: false,
        regularHolidayMonday: false,
        regularHolidaySaturday: false,
        regularHolidaySunday: false,
        regularHolidayThursday: false,
        regularHolidayTuesday: false,
        regularHolidayWednesday: false,
        showParentalForm: false,
        timeZone: null,
        isRedirect: true,
      };
    }
    return {
      ...state,
      loading: false,
    };
  }
  if (action.type === 'error') {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  }
  return state;
}
export default Reducer;
